"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTooltipMaxText = void 0;
/**
 * Returns the tooltip text for the increase button of quantity picker based of validity of the product and points currency.
 */
const getTooltipMaxText = ({
  isCampaignOffer,
  isHeartFormat,
  formatMessage
}) => {
  if (!isCampaignOffer) {
    return formatMessage('youAddedAMaximumNumber');
  }
  return formatMessage(isHeartFormat ? 'notEnoughHeartsCollected' : 'notEnoughPointsCollected');
};
exports.getTooltipMaxText = getTooltipMaxText;